/* eslint-disable no-alert */
/* eslint-disable import/prefer-default-export */
export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm('Wykryto zmiany na stronie. Czy odświeżyć?')
  if (answer === true) {
    window.location.reload()
  }
}
